import { Injectable, Pipe, PipeTransform } from '@angular/core';
import { CurrencyDataModel } from '../../models/currency-data.model';
import { FormatsService } from '../formats.service';
import { Utils } from '../utils';

@Pipe({
  name: 'trCurrencyData',
})
@Injectable({ providedIn: 'root' })
export class CurrencyDataPipe implements PipeTransform {
  constructor(private formats: FormatsService) {}

  transform(currencyCode: string) {
    let currencyData = new CurrencyDataModel();
    currencyData.symbol = Utils.checkCustomCurrencySymbol(
      currencyCode,
      this.formats.customCurrencySymbols
    );
    if (Utils.isValue(this.formats.customCurrencyPosition))
      currencyData.symbolPosition = this.formats.customCurrencyPosition;
    else currencyData.symbolPosition = this.formats.currencyPosition;
    currencyData.decimalSeparator = this.formats.decimalCharacter;
    currencyData.groupSeparator = this.formats.digitGroupSeparator;

    return currencyData;
  }
}
